import { ChangeDetectionStrategy, Component } from '@angular/core';
import { GridCellRenderer } from '@softapps/core/grid';
import { ProductGroup } from './product-group';

@Component({
  selector: 'soft-product-group-column',
  imports: [],
  template: `
    <div class="flex flex-col">
      <span class="soft-overline !mb-0">{{ value()?.produktgruppe }}</span>
      <span class="text-sm">{{ value()?.bezeichnung }}</span>
    </div>`,
  styles: `
    :host {
      display: block;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductGroupColumnComponent<TRow extends object> extends GridCellRenderer<TRow, ProductGroup>{

}
